<template>
  <v-container>
    <v-container fluid class="white fill-height align-center justify-center" >

      <div class="preview-wrapper mt-4">
        
        <div class="paper-preview" :style="estiloEscala">
          <vue-html2pdf
            :show-layout="true"
            :float-layout="false"
            :enable-download="false"
            :preview-modal="false"
            :paginate-elements-by-height="1100"
            :filename="'Pedido_' + (numeroPedidoExibicao || idPedido)"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            :html-to-pdf-options="htmlToPdfOptions"  @hasGenerated="aoGerarPdf"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              
              <div class="pdf-container" v-if="pedido" ref="conteudoPdf">
                
                <header class="pdf-header">
                  <div class="empresa-container">
                    <img 
                      v-if="logoEmpresaBase64" 
                      :src="logoEmpresaBase64" 
                      alt="Logo da Empresa" 
                      class="logo-empresa"
                    />
                    
                    <div class="empresa-dados">
                      <h1 class="empresa-nome">{{empresa.NomeEmpresa || 'NOME DA EMPRESA' }}</h1>
                      
                      <p v-if="empresa.EnderecoCompleto">{{ empresa.EnderecoCompleto }}</p>
                      <p v-else-if="empresa.Endereco">
                        {{ empresa.Endereco }} 
                        <span v-if="empresa.bairro"> - {{ empresa.bairro }}</span>
                        <span v-if="empresa.CidadeUF"> - {{ empresa.CidadeUF }}</span>
                      </p>

                      <p>
                        <span v-if="empresa.CpfCnpjFormatado">CNPJ: {{ empresa.CpfCnpjFormatado }}</span>
                        <span v-if="empresa.InscricaoEstadual"> - IE: {{ empresa.InscricaoEstadual }}</span>
                      </p>

                      <p>
                        <span v-if="empresa.Email">E-mail: {{ empresa.Email }}</span>
                        <span v-if="empresa.Telefone"> | Tel: {{ empresa.Telefone }}</span>
                      </p>
                    </div>
                  </div>
                  
                  <div class="pedido-info-box">
                    <h2 class="titulo-pedido">
                      {{ pedido.orcamento == 1 ? 'ORÇAMENTO' : 'PEDIDO' }} #{{ pedido.idpedidoback || pedido.idorcamentoback || pedido.idpedido }}
                    </h2>
                    
                    <div class="info-grid">
                      <div class="info-row">
                        <span class="label">Data:</span>
                        <span class="value">{{ formatarData(pedido.data) }}</span>
                      </div>
                    </div>
                  </div>
                </header>

                <div class="divisor"></div>

                <section class="info-section">
                  <div class="col-esq">
                    <h3 class="section-title">Cliente</h3>
                    <p class="dado-cliente"><strong>Cliente:</strong> {{ cliente.idcliente }} - {{ cliente.nome || '---' }}</p>
                    <p class="dado-cliente"><strong>CPF/CNPJ:</strong> {{ cliente.cnpjCpf || '---' }}</p>
                  <p class="dado-cliente"><strong>Endereço:</strong> {{ cliente.endereco }} {{ cliente.numero ? ', ' + cliente.numero : '' }}</p>
                    <p class="dado-cliente"><strong>Cidade/UF:</strong> {{ cliente.cidade }} - {{ cliente.uf }}</p>
                    <p class="dado-cliente"><strong>CEP:</strong> {{ cliente.cep || '---' }}</p>
                    <p class="dado-cliente"><strong>Tel:</strong> {{ cliente.fone || cliente.celular || '---' }}</p>
                </div>
                  
                  <div class="col-dir">
                    <h3 class="section-title">Condições</h3>
                    <p class="dado-cliente"><strong>{{ pedido.orcamento == 1 ? 'Nº Orçamento:' : 'Nº Pedido:' }}</strong> {{ pedido.idpedidoback || pedido.idorcamentoback || pedido.idpedido }}</p>
                    <p class="dado-cliente"><strong>Plano Pagto:</strong> {{ descricoes.plano || '---' }}</p>
                    <p class="dado-cliente"><strong>Forma Pagto:</strong> {{ descricoes.forma || '---' }}</p>
                    <p class="dado-cliente"><strong>Representante:</strong> {{ vendedorCodigo }} - {{ vendedorNome }}</p>
                  </div>
                </section>

                <section class="produtos-section">
                  <table class="tabela-itens">
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 8%">Foto</th>
                        <th class="text-left" style="width: 7%">Cód.</th>
                        <th class="text-left" style="width: 30%">Descrição</th> <th class="text-center" style="width: 5%">Un.</th>
                        <th class="text-right" style="width: 7%">Qtd</th>
                        <th class="text-right" style="width: 10%">Vlr. Unit.</th>
                        <th class="text-right" style="width: 7%">Desc.</th>
                        <th class="text-right" style="width: 10%">Vlr. Liq.</th>
                        <th class="text-right" style="width: 10%">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Filtrando a lista para ocultar linhas que possuam a propriedade DT_Cancelado -->
                      <tr v-for="(item, index) in itens.filter(i => !i.DT_Cancelado)" :key="index">
                        <td class="text-center espacoL td-imagem">
                          <img 
                            v-if="item.imagem" 
                            :src="item.imagem" 
                            alt="Produto" 
                            class="produto-img" 
                          />
                          <span v-else class="sem-foto"></span>
                        </td>
                        
                        <td class="text-center espaco espacoL">{{ item.codigo }}</td>
                        <td class="text-left espaco">
                          <div class="nome-produto">{{ item.descricao }}</div>
                          
                          <div v-if="item.observacao" class="badge-alerta">
                            <strong>Observação:</strong> {{ item.observacao }}
                          </div>
                          <div v-if="item.diluicao || item.substituicao">

                            <div v-if="item.diluicao" class="badge-info">
                              <strong>Diluição:</strong> {{ item.diluicao }} 
                              <div v-if="item.valorDiluido" class="badge-destaque">
                                Valor Diluído: {{ item.valorDiluido }}
                              </div>
                              <div v-if="item.substituicao" class="badge-alerta">
                                <strong>Substituição:</strong> {{ item.substituicao }}
                              </div>
                            </div>
                            
                          </div>
                        </td>
                        <td class="text-center espaco">{{ item.unidade }}</td>
                        <td class="text-right espaco">{{ formatarNumero(item.quantidade) }}</td>
                        <td class="text-right espaco">{{ formatarMoeda(item.valorunitario) }}</td>
                        <td class="text-right espaco">{{ formatarMoeda(item.valordesconto) }}</td>
                        <td class="text-right espaco">{{ formatarMoeda(item.valorliquido) }}</td>
                        <td class="text-right espaco font-weight-bold">{{ formatarMoeda(item.subtotal) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </section>

                <footer class="pdf-footer">
                  <div class="observacoes-box">
                    <strong style="display:block; margin-bottom:5px;">Observações:</strong>
                    <p>{{ pedido.observacao}}</p>
                  </div>

                  <div class="totais-box">
                    <div class="linha-total destaque">
                      <span>TOTAL A PAGAR:</span>
                      <span>{{ formatarMoeda(pedido.total) }}</span>
                    </div>
                  </div>
                </footer>
                
                <div class="assinatura-wrapper">
                    <div class="linha-assinatura">
                      ______________________________________________________________________<br>
                      Assinatura do Cliente
                    </div>
                </div>

              </div>
            </section>

          </vue-html2pdf>
        </div>
      </div>
      <v-speed-dial
        v-model="fabAberta"
        fixed
        bottom
        right
        direction="top"
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fabAberta"
            color="primary"
            dark
            fab
            large
            :loading="gerando"
            :disabled="loading"
          >
            <v-icon v-if="fabAberta">mdi-close</v-icon>
            <v-icon v-else>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-btn
          fab
          dark
          small
          color="green"
          @click="baixarPdf"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>

        <v-btn
          fab
          dark
          small
          color="blue"
          @click="compartilharPdf"
        >
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-container>
  </v-container>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import db from '@/plugins/dexie'
import moment from 'moment'
import html2pdf from 'html2pdf.js'

export default {
  name: 'ImpressaoPedido',
  components: { VueHtml2pdf },
  props: {
    modoComponente: { type: Boolean, default: false }
  },
  
  data() {
    return {
      fabAberta: false,
      pdfPronto: null,
      logoEmpresaBase64: null,
      htmlToPdfOptions: {
        margin: [10, 10, 25, 10], 
        filename: 'pedido.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      },
      dataImpressao: '',
      idPedido: null,
      loading: true,
      gerando: false,
      fatorEscala: 1,
      pedido: null,
      cliente: {},
      itens: [],
      descricoes: { forma: '', plano: '', tipo: '', destino: '' },
      vendedorNome: '---',
      vendedorCodigo: '---',
      empresa: {
        nome: '',
        endereco: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        cnpj: '',
        telefone: ''
      }
    }
  },

  computed: {
    totalProdutos() {
      return this.itens.reduce((acc, item) => acc + item.subtotal, 0);
    },
    numeroPedidoExibicao() {
      if (!this.pedido) return this.idPedido || '';
      return this.pedido.idpedidoback || this.pedido.idorcamentoback || this.pedido.idpedido || this.idPedido || '';
    },
    estiloEscala() {
      return {
        transform: `scale(${this.fatorEscala})`,
        transformOrigin: 'top center',
        height: 'auto',
        display: 'block', 
        marginBottom: '50px'
      }
    }
  },

  async mounted() {
    if (!this.modoComponente) {
      this.idPedido = this.$route.query.id;
      if (this.idPedido) {
        await this.carregarDados(this.idPedido);
        this.pdfPronto = await this.gerarPdfBlob(this.idPedido);

        const acaoAutomatica = this.$route.query.acao;
        
        if (acaoAutomatica === 'baixar') {
          this.baixarPdf();
        } else if (acaoAutomatica === 'compartilhar') {
          this.compartilharPdf();
        }

      } else {
        this.voltar();
      }
      this.calcularEscala();
      window.addEventListener('resize', this.calcularEscala);
    }
  },
  

  methods: {

    baixarPdf() {
      if (!this.pdfPronto) {
        alert("O PDF está sendo preparado. Por favor, aguarde mais um segundo.");
        return;
      }
      this.aoGerarPdf(this.pdfPronto);
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    async compartilharPdf() {
      if (!this.pdfPronto) {
        alert("O PDF está sendo preparado. Por favor, aguarde mais um segundo e tente novamente.");
        return;
      }

      const isOrcamento = this.pedido && this.pedido.orcamento == 1;
      const tipoDoc = isOrcamento ? 'Orçamento' : 'Pedido';
      const numExibicao = this.numeroPedidoExibicao || this.idPedido;
      const fileName = `${tipoDoc}_${numExibicao}.pdf`;
      
      const file = new File([this.pdfPronto], fileName, { type: 'application/pdf' });

      try {
        if (!navigator.canShare || !navigator.canShare({ files: [file] })) {
          alert("Seu navegador não suporta o compartilhamento nativo deste arquivo. Baixando...");
          this.aoGerarPdf(this.pdfPronto);
          return;
        }

        await navigator.share({
          title: `${tipoDoc} #${numExibicao}`,
          text: `Segue em anexo o ${tipoDoc.toLowerCase()} #${numExibicao} gerado por ${this.vendedorNome}.`, 
          files: [file]
        });
        
        console.log(`Segue em anexo o ${tipoDoc.toLowerCase()} #${numExibicao} gerado por ${this.vendedorNome}.`);

      } catch (error) {
        if (error.name !== 'AbortError' && !error.message.includes('abort')) {
          alert("Erro ao compartilhar: " + error.message);
        }
      }
    },
    
    calcularEscala() {
      const larguraTela = window.innerWidth;
      const larguraPDF = 840;
      
      if (larguraTela < larguraPDF) {
        this.fatorEscala = (larguraTela - 20) / 800; 
      } else {
        this.fatorEscala = 1;
      }
    },

    async gerarPdfBlob(idPedidoExterno) {
      this.loading = true;
      try {
        await this.carregarDados(idPedidoExterno);
        
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 500));

        const element = this.$refs.conteudoPdf;
        const options = {
          ...this.htmlToPdfOptions,
          margin: [10, 10, 30, 10], 
          pagebreak: { mode: ['css', 'legacy'] },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        const worker = html2pdf().set(options).from(element).toPdf();

        await worker.get('pdf').then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            
            pdf.setFont('Arial', 'normal');
            pdf.setFontSize(8);
            pdf.setTextColor(80, 80, 80);

            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const texto = `Usuário: ${this.vendedorNome} - Página ${i} de ${totalPages}`;
                let yPos = (pageHeight > 400) ? (pageHeight - 30) : (pageHeight - 10);
                pdf.text(texto, pageWidth / 2, yPos, { align: 'center' });
            }
        });

        const pdfBlob = await worker.output('blob');

        return pdfBlob;

      } catch (error) {
        console.error("Erro ao gerar Blob do PDF:", error);
        alert("Erro técnico ao gerar PDF: " + error.message);
        return null;
      } finally {
        this.loading = false;
      }
    }, 

    async carregarDados(id) {
      this.loading = true;
      try {
        const listaEmpresas = await db.empresa.toArray();
        if (listaEmpresas.length > 0) {
          this.empresa = listaEmpresas[0];
          if (this.empresa.CaminhoImagemDuplicata) {
            try {
              let blob = this.empresa.CaminhoImagemDuplicata;
              if (!(blob instanceof Blob)) {
                blob = new Blob([blob], { type: 'image/jpeg' });
              }
              this.logoEmpresaBase64 = await this.blobToBase64(blob);
            } catch (e) {
              console.error("Erro ao processar o logo da empresa:", e);
            }
          }

        } else {
          this.empresa = { NomeEmpresa: 'Empresa não sincronizada' };
        }

        let pedido = await db.pedido.where('idpedido').equals(parseInt(id)).first();
        if(!pedido) pedido = await db.pedido.where('idpedido').equals(String(id)).first();

        if (pedido) {
          this.pedido = pedido;
          let idOuCodigoVendedor = pedido.idvendedor;
          this.vendedorNome = '---';

          if (!idOuCodigoVendedor) {
            try {
              const param = await db.parametro.limit(1).first();
              if (param && param.idvendedorlogado) {
                idOuCodigoVendedor = param.idvendedorlogado;
                this.pedido.idvendedor = idOuCodigoVendedor;
              }
            } catch (e) { console.error("Erro ao buscar parametro:", e); }
          }

          if (idOuCodigoVendedor) {
            const todosVendedores = await db.vendedor.toArray();
            const vend = todosVendedores.find(v => 
              v.idvendedor == idOuCodigoVendedor
            );
            if (vend) {
              this.vendedorNome = vend.nome;
              this.vendedorCodigo = vend.codigo || vend.idvendedor; 
            } else {
              this.vendedorNome = 'Não encontrado';
              this.vendedorCodigo = idOuCodigoVendedor;
            }
          }

          if (pedido.idcliente) {
            let cli = await db.cliente.where('idcliente').equals(parseInt(pedido.idcliente)).first();
            if(!cli) cli = await db.cliente.where('idcliente').equals(String(pedido.idcliente)).first();
            this.cliente = cli || { nome: 'Cliente não encontrado' };
          }

          if (pedido.idformapagto) {
            const forma = await db.formapagto.where('idformapagto').equals(parseInt(pedido.idformapagto)).first();
            this.descricoes.forma = forma ? forma.descricao : '';
          }
          if (pedido.idplanopagto) {
            const plano = await db.planopagamento.where('idplanopagto').equals(parseInt(pedido.idplanopagto)).first();
            this.descricoes.plano = plano ? plano.descricao : '';
          }
          if (pedido.idtipopedidovenda) {
            const tipo = await db.tipopedidovenda.where('idtipopedidovenda').equals(parseInt(pedido.idtipopedidovenda)).first();
            this.descricoes.tipo = tipo ? tipo.descricao : '';
          }
          if (pedido.iddestinoitem) {
            const dest = await db.destinoitem.where('iddestinoitem').equals(parseInt(pedido.iddestinoitem)).first();
            this.descricoes.destino = dest ? dest.descricao : '';
          }

          let itensRaw = await db.pedidoitem.where('idpedido').equals(pedido.idpedido).toArray();
          if (itensRaw.length === 0) itensRaw = await db.pedidoitem.where('idpedido').equals(String(pedido.idpedido)).toArray();

          this.itens = await Promise.all(itensRaw.map(async (item) => {
            let desc = item.descricao;
            let unid = 'UN';
            let prod = null; 
            let imagemBase64 = null;

            if (item.idcortamanhofinal) {
                prod = await db.produto.where('idcortamanhofinal').equals(parseInt(item.idcortamanhofinal)).first();
                
                if (!prod) {
                  prod = await db.produto.where('idcortamanhofinal').equals(String(item.idcortamanhofinal)).first();
                }
                
                if (prod) {
                  // AJUSTE: Prioriza a descrição vinda do cadastro de produto se o item do pedido estiver sem nome
                  desc = prod.descricao || item.descricao;
                  unid = prod.un || 'UN';
                  
                  let imgRecord = null;
                  if (db.imagem && prod.idcortamanhofinal) {
                    const idCtfNum = Number(prod.idcortamanhofinal);
                    if (!isNaN(idCtfNum)) {
                      imgRecord = await db.imagem.where('idcortamanhofinal').equals(idCtfNum).first();
                    }
                    if (!imgRecord) {
                      imgRecord = await db.imagem.where('idcortamanhofinal').equals(String(prod.idcortamanhofinal)).first();
                    }
                  }

                  let blob = imgRecord ? (imgRecord.imgBlob1 || imgRecord.imgBlob2 || imgRecord.imgBlob3) : null;
                  
                  if (blob) {
                    try {
                      if (!(blob instanceof Blob)) {
                        blob = new Blob([blob], { type: 'image/jpeg' });
                      }
                      imagemBase64 = await this.blobToBase64(blob);
                    } catch (e) {
                      console.error("Erro ao processar imagem para o PDF:", e);
                    }
                  }
                }
            }

            const qtd = item.quantidade || 0;
            const vlrUnitario = item.valorunitario || 0;
            const vlrDesconto = item.valordesconto || 0; 
            const vlrLiquido = vlrUnitario - vlrDesconto;

            let diluicaoStr = item.textodiluicao || item.textoDiluicao || null;
            let valorDiluidoDB = item.valordiluido || item.valorDiluido || null;
            let valorDiluidoFormatado = null;

            if (valorDiluidoDB) {
              valorDiluidoFormatado = parseFloat(valorDiluidoDB).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return {
              codigo: item.idcortamanhofinal,
              descricao: desc || `Item ${item.idcortamanhofinal}`,
              unidade: unid,
              quantidade: qtd,
              valorunitario: vlrUnitario,
              valordesconto: vlrDesconto,
              valorliquido: vlrLiquido,
              subtotal: qtd * vlrLiquido,
              imagem: imagemBase64,
              diluicao: diluicaoStr,
              substituicao: item.textosubstituicao || item.textoSubstituicao || null,
              valorDiluido: valorDiluidoFormatado,
              observacao: item.observacao,
              DT_Cancelado: item.DT_Cancelado 
            };
          }));
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        this.loading = false;
      }
    },

    async prepararEGerarPdf() {
      this.gerando = true;
      this.dataImpressao = new Date().toLocaleString('pt-BR');
      await this.$nextTick(); 

      const element = this.$refs.conteudoPdf;
      const options = {
        ...this.htmlToPdfOptions,
        margin: [10, 10, 30, 10], 
        pagebreak: { mode: ['css', 'legacy'] },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };

      html2pdf()
        .set(options)
        .from(element)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          
          pdf.setFont('times', 'normal');
          pdf.setFontSize(8);
          pdf.setTextColor(80, 80, 80);

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            const texto = `Usuário: ${this.vendedorNome}                                                                                                                                                                    Página ${i} de ${totalPages}`;
            let yPos = (pageHeight > 400) ? (pageHeight - 30) : (pageHeight - 10);
            pdf.text(texto, pageWidth / 2, yPos, { align: 'center' });
          }
        })
        .output('blob')
        .then((blobPdf) => {
          this.aoGerarPdf(blobPdf);
        })
        .catch((err) => {
          console.error("Erro:", err);
          alert('Erro ao gerar PDF');
        })
        .finally(() => {
          this.gerando = false; 
        });
    },

    async aoGerarPdf(blobPdf) {
      try {
        const url = window.URL.createObjectURL(blobPdf);
        const link = document.createElement('a');
        link.href = url;
        const isOrcamento = this.pedido && this.pedido.orcamento == 1;
        const prefixoArquivo = isOrcamento ? 'Orcamento' : 'Pedido';
        const numExibicao = this.numeroPedidoExibicao || this.idPedido;
        link.setAttribute('download', `${prefixoArquivo}_${numExibicao}.pdf`);
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao baixar PDF:", error);
      } finally {
        this.gerando = false;
      }
    },

    voltar() {
      this.$router.replace({ 
          path: '/cadastro-pedido', 
          query: { id: this.idPedido } 
      });
    },
    formatarMoeda(val) {
      if(!val && val !== 0) return '0,00';
      return val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatarNumero(val) {
      if(!val && val !== 0) return '0';
      return Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    formatarData(val) {
      if(!val) return '';
      try {
        return moment(val).format('DD/MM/YYYY HH:mm');
      } catch(e) { return val; }
    }
  }
}
</script>

<style scoped>

.preview-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: visible; 
}

.paper-preview {
  background-color: white;
  width: 800px;    
  max-width: 800px;      
  min-width: 800px;
  min-height: 1100px;
  height: auto;
  margin: 0 auto;
  padding: 15px;    
  box-sizing: border-box; 
  position: relative;
  font-family: Arial, Helvetica, sans-serif;
  color: #333;
  line-height: 1.3;
}

.pdf-header {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 25px;
  border-bottom: 2px solid #333;
  padding-bottom: 15px;
}

.empresa-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}

.empresa-dados p { 
  margin: 2px 0; 
  font-size: 14px; 
}
.logo-empresa {
  max-width: 180px;
  max-height: 80px;
  object-fit: contain;
  display: block;
  margin-bottom: 0;
}
.pedido-info-box { 
  width: 100%; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  padding: 6px 12px;
  border-radius: 4px;
}

.titulo-pedido {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

.pdf-container {
  font-family: Arial, Helvetica, sans-serif;
  color: #333;
  width: 100%;
}

.empresa-box { 
  width: auto; 
}

.empresa-nome {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 5px;
}

.empresa-box p { 
  margin: 2px 0; 
  font-size: 14px; 
}

.info-row { 
  font-size: 16px; 
  margin-bottom: 4px; 
}
.info-row .label { font-weight: bold; margin-right: 5px; }

.info-section {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  gap: 0;
}

.col-esq { 
  width: 55%; 
  padding-right: 15px;
}
.col-dir { 
  width: 45%; 
  padding-right: 0;
}

.td-imagem {
  padding: 2px !important;
  vertical-align: middle;
}

.produto-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}

.sem-foto {
  color: #bbb;
  font-size: 12px;
}

.espaco{
  border-right: 1px solid #ccc;
}

.espacoL{
  border-left: 1px solid #ccc;
}


.section-title {
  font-size: 16px;
  font-weight: bold;
  background-color: #eee;
  padding: 4px 8px;
  margin-bottom: 8px;
  border-left: 3px solid #4d4d4d;
}

.dado-cliente { 
  font-size: 14px; 
  margin-bottom: 3px; 
}

.produtos-section {
  width: 100%;
  overflow-x: hidden;
  margin-bottom: 20px;
}

.tabela-itens {
  width: 100%;
  min-width: auto;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

.tabela-itens th {
  background-color: #444;
  color: white;
  padding: 8px;
  font-weight: bold;
  text-transform: uppercase;
}
.tabela-itens td {
  border-bottom: 1px solid #ddd;
  padding: 6px 8px;
}
.tabela-itens tr:nth-child(even) { background-color: #f9f9f9; }

.pdf-footer {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  page-break-inside: avoid;
}

.observacoes-box {
  width: 60%;
  font-size: 14px;
  border: 1px solid #eee;
  padding: 10px;
  background-color: #fdfdfd;
}

.totais-box {
  width: 35%;
  background-color: #f5f5f5;
  padding: 10px;
}

.linha-total {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 13px;
}
.linha-total.destaque {
  margin-top: 10px;
  padding-top: 5px;
  border-bottom: 1px solid #999;
  font-weight: bold;
  font-size: 13px;
  color: #000;
}

.assinatura-wrapper {
  margin-top: 60px;
  text-align: center;
  page-break-inside: avoid;
}
.linha-assinatura {
  display: inline-block;
  font-size: 14px;
}

.text-right { text-align: right; }
.text-center { text-align: center; }
.text-left { text-align: left; }
.font-weight-bold { font-weight: bold; }

thead { display: table-header-group; }
tfoot { display: table-row-group; }
.tabela-itens tr { page-break-inside: avoid; page-break-after: auto; }

.nome-produto {
  font-weight: bold;
  margin-bottom: 4px;
}


.badge-alerta {

  border-radius: 2px;
  width: fit-content;
}

.badge-info {
  font-size: 13px;
  border-radius: 2px;
  width: fit-content;
}

.badge-destaque {
  font-weight: bold;
}

</style>